import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VModal from "vue-js-modal";
import Default from "./layouts/Default";
import Dashboard from "./layouts/Dashboard";
import NoSidebar from "./layouts/NoSidebar";
import Toasted from "vue-toasted";
import VueSelect from "vue-select";
import "vue-material-design-icons/styles.css";
import "@mdi/font/css/materialdesignicons.css";
import "vue-select/dist/vue-select.css";
import "./assets/css/tokens.css";
import "./assets/css/main.css";
import "./utils/vee-validate";
import {
  enableThermalPrinterMock,
  disableThermalPrinterMock,
  initThermalPrinterMock
} from "./utils/thermalPrintMock";

// Dev-only test utilities
if (process.env.NODE_ENV === "development") {
  import("./utils/testMessageTemplates").then(module => {
    window.testMessageTemplates = module.testMessageTemplates;
  });
  window.enableThermalPrinterMock = enableThermalPrinterMock;
  window.disableThermalPrinterMock = disableThermalPrinterMock;
  initThermalPrinterMock();
}

Vue.use(Toasted, {
  position: "bottom-center",
  duration: 3500,
  keepOnHover: true
});
Vue.use(VModal);

Vue.component("default-layout", Default);
Vue.component("app-layout", Dashboard);
Vue.component("nosidebar-layout", NoSidebar);
Vue.component("v-select", VueSelect);
Vue.component("page-heading", resolve => {
  import("./components/PageHeading").then(AsyncComponent => {
    resolve(AsyncComponent.default);
  });
});

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
